(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
  
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
  
          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
  
              if (recommendations && recommendations.innerHTML.trim().length) {
                // CLS: the server now renders a fallback rail, so this is a REPLACE,
                // not a fill. columns_mobile is 6 (2-up) with products_to_show 4, so
                // four cards occupy two rows; a response carrying two or fewer
                // collapses that to one row and yanks the bundle bar and footer up
                // ~320px. Field CLS is 0 today and this must not be what breaks it.
                // Swap only when it cannot be seen happening: the incoming rail is at
                // least as tall, or the element is still below the fold (which the
                // 500px rootMargin below makes the usual case anyway).
                const incoming = recommendations.querySelectorAll('.grid__item').length;
                const current = this.querySelectorAll('.grid__item').length;
                if (incoming >= current || this.getBoundingClientRect().top >= window.innerHeight) {
                  this.innerHTML = recommendations.innerHTML;
                }
              }
  
              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              }
              if (window.SPR && theme.review ) {
                if ($('.shopify-product-reviews-badge').length > 0) {
                  return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                };
              }
            })
            .catch(e => {
              console.error(e);
            });
        }
  
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
      }
    }
  
    customElements.define('product-recommendations', ProductRecommendations);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s_timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("s-timeline__img--bounce-in"),t.contents[e].classList.add("s-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-s-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
